<div class="page-header">
  <div class="left">
    <a [routerLink]="['/']">
      <img src="assets/inwedio-logo.svg" alt="Inwedio" class="logo" />
    </a>
    <div class="org-select" #orgTrigger (click)="toggleOrgDropdown()">
      <span class="org-name" *ngIf="currentOrgId$ | async as oid; else selectOrg">
        {{ (currentOrg$ | async)?.name || 'Select organisation' }}
      </span>
      <ng-template #selectOrg>Select organisation</ng-template>
      <span class="arrow" aria-hidden="true">▾</span>
    </div>
    <div class="org-dropdown" #orgDropdown *ngIf="showOrgDropdown">
      <div class="org-dropdown-list">
        <div class="org-item" *ngFor="let o of orgs$ | async" (click)="onSelectOrg(o.id)">
          <div class="org-item-name">{{ o.name }}</div>
          <div class="org-item-role" *ngIf="myUserId$ | async as uid">
            <span *ngIf="o.roles?.[uid]?.type as role">[{{ role }}]</span>
          </div>
        </div>
        <div class="empty" *ngIf="(orgs$ | async)?.length === 0">No organisations</div>
      </div>
    </div>
  </div>
  <div class="right" *ngIf="myUser$ | async as me">
    <div class="avatar">{{ (me.firstName || '?')[0] }}{{ (me.lastName || '')[0] }}</div>
    <div class="name">{{ me.firstName }} {{ me.lastName }}</div>
  </div>
</div>

